import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import SectionHeader, { CTABar } from "@/components/site/SectionHeader";
import { SERVICES } from "@/components/site/content";

export default function ServicesPage() {
  return (
    <div data-testid="services-page">
      <section className="section-pad bg-white">
        <div className="container-tight">
          <SectionHeader overline="Services" title="End-to-End Workforce Solutions" subtitle="Six focused practice areas working together to help you hire faster, run compliantly and scale with confidence." />
          <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {SERVICES.map((s) => (
              <div key={s.key} data-testid={`services-card-${s.key}`} className="group bg-white rounded-2xl border border-border p-8 hover:shadow-xl hover:-translate-y-1 hover:border-gold-400/60 transition-all duration-300">
                <div className="h-14 w-14 grid place-items-center rounded-xl bg-navy-800 text-white group-hover:bg-gold-500 transition-colors">
                  <s.icon size={28} weight="duotone" />
                </div>
                <h3 className="mt-6 font-serif text-2xl text-navy-800">{s.title}</h3>
                <p className="mt-3 text-sm text-muted-foreground leading-relaxed">{s.desc}</p>
                <Link to="/employers" data-testid={`services-cta-${s.key}`} className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-navy-800 hover:text-gold-600">
                  Learn More <ArrowRight size={14} />
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTABar
        title="Not sure where to start?"
        text="Tell us your workforce challenge — our team will recommend the right service mix."
        primary={{ to: "/employers", label: "Submit Requirement" }}
        secondary={{ to: "/contact", label: "Talk to Our Team" }}
        testid="services-cta-bar"
      />
    </div>
  );
}
